// eslint-disable-next-line import/prefer-default-export
export const STATUS_EXPIRATION_WINDOW = 5 * 60000; // 5 minutes
